import React from "react";
import {
  BrowserRouter,
  Navigate,
  Route,
  Routes,
} from "react-router-dom";
import WowInit from "../../components/wowInit/wowInit";
import Homepage from "../HomePage";
import AboutPage from "../AboutPage/AboutPage";
import ServicePage from "../ServicePage/ServicePage";
import SeviceSinglePage from "../SeviceSinglePage/SeviceSinglePage";
import ContactPage from "../ContactPage/ContactPage";
import ErrorPage from "../ErrorPage/ErrorPage";
import ScrollToTop from "./ScrollToTop";
import {
  AccessibilityPage,
  FundingPage,
  LegalPage,
  PedagogyPage,
  PrivacyPage,
} from "../InformationPage/InformationPage";

const AllRoute: React.FC = () => (
  <div className="App">
    <BrowserRouter>
      <WowInit />
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Homepage />} />
        <Route path="/home" element={<Navigate to="/" replace />} />
        <Route path="/a-propos" element={<AboutPage />} />
        <Route path="/formations" element={<ServicePage />} />
        <Route
          path="/formations/vtest-business-english-4-skills"
          element={<SeviceSinglePage />}
        />
        <Route path="/methode-pedagogique" element={<PedagogyPage />} />
        <Route path="/financement" element={<FundingPage />} />
        <Route path="/accessibilite" element={<AccessibilityPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/mentions-legales" element={<LegalPage />} />
        <Route
          path="/politique-confidentialite"
          element={<PrivacyPage />}
        />

        <Route path="/about" element={<Navigate to="/a-propos" replace />} />
        <Route path="/service" element={<Navigate to="/formations" replace />} />
        <Route
          path="/service-details"
          element={
            <Navigate
              to="/formations/vtest-business-english-4-skills"
              replace
            />
          }
        />
        <Route path="/ai-marketing" element={<Navigate to="/" replace />} />
        <Route path="/ai-chatbot" element={<Navigate to="/" replace />} />

        <Route path="/404" element={<ErrorPage />} />
        <Route path="*" element={<ErrorPage />} />
      </Routes>
    </BrowserRouter>
  </div>
);

export default AllRoute;
